<section class="problem-section py-5">
    <div class="container">
        <div class="row align-items-center flex-column-reverse flex-lg-row">
            <!-- Textbereich -->
            <div class="col-lg-7">
                <span class="badge bg-danger bg-gradient mb-3 px-3 py-2 fs-6 fw-semibold">
                  Problem im B2B-Vertrieb
                </span>
                <h1 class="display-5 fw-bold text-dark mb-4">
                    Schluss mit zeitaufwändiger Recherche<br>
                    <span class="text-primary">und ungenauen Datenquellen</span>
                </h1>
                <p class="lead text-secondary mb-4">
                    Wer im B2B-Bereich Neukunden gewinnen oder gezielte Marketingkampagnen starten will, kennt das Problem:
                </p>
                <ul class="problem-list list-unstyled mb-4">
                    <li>
                        <i class="fa fa-exclamation-circle text-danger me-2"></i>
                        Das Sammeln und Pflegen aktueller Firmeninformationen ist oft aufwendig, unvollständig und mit hohen Streuverlusten verbunden.
                    </li>
                    <li>
                        <i class="fa fa-exclamation-circle text-danger me-2"></i>
                        Unstrukturierte Listen, veraltete Kontaktdaten und fehlende Social-Media-Links erschweren die zielgenaue Ansprache Ihrer Wunschkunden.
                    </li>
                    <li>
                        <i class="fa fa-exclamation-circle text-danger me-2"></i>
                        Sie verschwenden Zeit, Geld und Nerven – und verlieren wertvolle Chancen im Vertrieb.
                    </li>
                </ul>
                <a class="btn btn-primary btn-lg px-4 shadow-sm" href="#cta">
                    Jetzt Starten <i class="fa fa-arrow-right ms-2"></i>
                </a>
            </div>
            <div class="col-lg-5 mb-5 mb-lg-0 text-center">
                <img src="assets/images/HeadacheGirl.png"
                     alt="Daten Recherche Problem"
                     class="img-fluid problem-visual shadow-sm rounded-4">
            </div>
        </div>
    </div>
</section>
